import React from "react";
import { Inbox } from "lucide-react";

/**
 * <EmptyState> — friendly zero-data card used across tables & lists.
 *
 * <EmptyState
 *   title="No estimates yet"
 *   body="Once you send a quote, it will land here for tracking."
 *   icon={FileSignature}
 *   action={{ label: "New estimate", onClick: () => setOpen(true) }}
 * />
 */
export default function EmptyState({
  title = "Nothing here yet",
  body,
  icon: Icon = Inbox,
  action,
  className = "",
  testId,
}) {
  return (
    <div
      data-testid={testId || "empty-state"}
      className={`card-pb p-10 sm:p-14 text-center ${className}`}
    >
      <div className="w-14 h-14 rounded-2xl bg-[#C9A356]/10 grid place-items-center mx-auto mb-4">
        <Icon className="w-6 h-6 text-[#C9A356]" />
      </div>
      <h3 className="font-heading text-lg text-[#0A2540] dark:text-white">{title}</h3>
      {body ? (
        <p className="text-sm text-[#475569] dark:text-slate-400 mt-1.5 max-w-sm mx-auto leading-relaxed">
          {body}
        </p>
      ) : null}
      {action ? (
        <button
          type="button"
          onClick={action.onClick}
          data-testid={action.testId}
          className="mt-5 inline-flex items-center gap-1.5 h-10 px-4 rounded-md bg-[#0A2540] text-white text-sm font-semibold hover:bg-[#12365b] transition"
        >
          {action.label}
        </button>
      ) : null}
    </div>
  );
}
